'use client';

import { useEffect, useMemo } from 'react';
import type { RouteMetaPayload } from '../../_libs/site-shell/routeMeta';
import { resolveRouteMetaDisableFooterDisplayAd } from '../../_libs/site-shell/routeMeta';
import { useRouteMetaRegistration } from './RouteMetaContext';

export function RouteMeta({
  metaProps,
  pageTargeting,
  disableFooterDisplayAd,
  disableStickyFooter,
  disableRaptiveFooter,
  article,
  post,
  term,
  disablePageTracking,
}: RouteMetaPayload) {
  const { pathname, registerRouteMeta } = useRouteMetaRegistration();
  const footerDisplayAdDisabled =
    disableFooterDisplayAd !== undefined ||
    disableStickyFooter !== undefined ||
    disableRaptiveFooter !== undefined
      ? resolveRouteMetaDisableFooterDisplayAd({
          disableFooterDisplayAd,
          disableStickyFooter,
          disableRaptiveFooter,
        })
      : undefined;

  const payload = useMemo<RouteMetaPayload | null>(() => {
    const hasPayload =
      metaProps ||
      pageTargeting ||
      footerDisplayAdDisabled !== undefined ||
      article ||
      post ||
      term ||
      disablePageTracking !== undefined;

    return hasPayload
      ? {
          metaProps,
          pageTargeting,
          disableFooterDisplayAd: footerDisplayAdDisabled,
          article,
          post,
          term,
          disablePageTracking,
        }
      : null;
  }, [metaProps, pageTargeting, footerDisplayAdDisabled, article, post, term, disablePageTracking]);

  registerRouteMeta(payload);

  useEffect(() => {
    return () => registerRouteMeta(null, pathname);
  }, [registerRouteMeta, pathname]);

  return null;
}
